import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import _ from 'lodash';

import DefaultSelect from '../../../shared/default-select/components/default-select';
import dashboardConstants from '../constants/dashboard-constants';
import Helpers from '../../../../common/helpers';
import { handleQuickLinkChange } from '../actions/dashboard-actions';

class QuickLinksSelector extends Component {
  state = {
    links: [],
    selectedLink: null,
    campaign: null,
  };

  componentDidMount() {
    const { profile, campaigns, change, handleQuickLinkChange, sites } = this.props;
    const campaign = campaigns && campaigns.length > 0 ? campaigns[0] : {};
    const link = sites[0] || {};
    this.setState({ selectedLink: link.page_code, campaign: campaign.partner_code });
    change('campaign', campaign.partner_code || '');
    change('link', link.page_code || '');
    const url = link
      ? Helpers.formUrl(link, {
          reason: profile && profile.user_name,
          refcode: campaign.partner_code,
          code: campaign.partner_code,
        })
      : '';
    handleQuickLinkChange(url);
  }

  handleDropdownChange(event) {
    const { campaign } = this.state;
    const { handleQuickLinkChange, sites, profile } = this.props;
    const link = _.find(sites, { page_code: event.target.value });

    this.setState({ selectedLink: event.target.value });
    const url = link
      ? Helpers.formUrl(link, {
          reason: profile && profile.user_name,
          refcode: campaign,
          code: campaign,
        })
      : '';
    handleQuickLinkChange(url);
  }

  handleCampaignsChange(event) {
    const { profile, handleQuickLinkChange, sites } = this.props;
    const { selectedLink } = this.state;
    const link = _.find(sites, { page_code: selectedLink });
    const url = link
      ? Helpers.formUrl(link, {
          reason: profile && profile.user_name,
          refcode: event.target.value,
          code: event.target.value,
        })
      : '';

    this.setState({ campaign: event.target.value });
    handleQuickLinkChange(url);
  }

  render() {
    const { t } = this.context;
    const { campaigns, sites } = this.props;

    return (
      <div className="activity-summary-container__quick-links">
        <p className="activity-summary-container__quick-links__title">{t('DASHBOARD.QUICK_LINKS')}</p>
        <form noValidate className="login-container__wrapper__main__form">
          <div className="row">
            <div className="col-md-12">
              <Field
                name={'link'}
                inputName={'link'}
                label={'DASHBOARD.LINKS_LABEL'}
                options={sites}
                optionLabel={'page_name'}
                optionValue={'page_code'}
                component={DefaultSelect}
                onChange={e => this.handleDropdownChange(e)}
              />
            </div>
            <div className="col-md-12 m-t-20">
              <Field
                name={'campaign'}
                inputName={'campaign'}
                label={'BANNERS.SELECT_CAMPAIGN'}
                options={campaigns}
                optionLabel={'link_name'}
                customLabel={'CAMPAIGNS.MOBILE_TRAFFIC'}
                optionValue={'partner_code'}
                component={DefaultSelect}
                onChange={e => this.handleCampaignsChange(e)}
              />
            </div>
          </div>
        </form>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  profile: state.userProfileReducer.profile,
  campaigns: state.campaignsReducer.campaigns,
  sites: state.linkCreatorReducer.sites,
});

const mapDispatchToProps = dispatch => ({
  handleQuickLinkChange: link => {
    dispatch(handleQuickLinkChange(link));
  },
});

QuickLinksSelector.contextTypes = {
  t: PropTypes.func.isRequired,
};

QuickLinksSelector = reduxForm({
  form: dashboardConstants.quick_links_form,
})(QuickLinksSelector);

export default connect(mapStateToProps, mapDispatchToProps)(QuickLinksSelector);



// WEBPACK FOOTER //
// ./src/app/main/dashboard/components/quick-links-selector.js